var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},[_c('p',{staticClass:"mb-2 font-bold text-gray-700 ds-text-xl"},[_vm._v("No matching results.")]),_c('p',{staticClass:"ds-text-base normal text-gray-500"},[_vm._v(" Want to discover new athletes? Check out the "),_c('a',{attrs:{"href":"/recruits"}},[_vm._v(" Discover Feed "),_c('i',{staticClass:"sr-2 sr-v2-arrow-right"})])])])
}]

export { render, staticRenderFns }